import { Directive, Input, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';

@Directive({
  selector: '[hasRole]',
  standalone: true
})
export class HasRoleDirective implements OnInit {
  @Input('hasRole') expectedRole!: string;

  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private dataService = inject(DataService);

  ngOnInit() {
    this.dataService.getRole().subscribe(roleData => {
      if (roleData?.code === this.expectedRole) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}